<template>
  <div class="select">
    <select
      required
      :class="classes.select"
      :id="attributes.id"
      v-bind="attributes"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      @click="$emit('click', $event)"
    >
      <option
        v-for="option in options"
        :disabled="isFieldDisabled"
        :key="option.value"
        :value="option.value"
        :hidden="option.hidden"
      >
        {{ option.label }}
      </option>
    </select>

    <label v-if="label" for="select" :class="classes.label"> {{ label }} </label>
  </div>
</template>

<script>
export default {
  name: 'VSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    errorMessage: String,
    errorWarning: Boolean,
    label: String,
  },

  computed: {
    classes() {
      return {
        select: {
          select__camp: true,
          'select__camp--error': this.errorMessage || this.errorWarning,
        },
        label: {
          select__camp__label: true,
          'select__camp__label--error': this.errorMessage || this.errorWarning,
        },
      };
    },

    isFieldDisabled() {
      return this.attributes.readonly;
    },

    attributes() {
      return {
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
select:valid + label {
  font-size: 0.73rem;
  color: var(--color-grey-7);
  top: 0.1rem;
}

.select {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  &__camp {
    transition: all 0.3s ease-out;
    background-color: rgba(22, 22, 22, 0.04);
    border: 0;
    border-radius: 4px 4px 0 0;
    border-bottom: 2px solid #4b4b4b;

    &:focus {
      border-bottom: 2px solid var(--color-secondary);
    }

    &[readonly],
    &:disabled {
      border-bottom: 2px solid var(--color-grey-7);
      cursor: not-allowed;
      background-color: var(--color-grey-4);
      user-select: none;
    }

    &[readonly] + label,
    &:disabled + label {
      font-size: 0.73rem;
      color: var(--color-grey-7);
      top: 0.1rem;
    }

    &--error {
      border-bottom: 2px solid var(--color-error);
      color: var(--color-error);
    }

    &__label {
      top: 1rem;
      transition: all 0.2s ease-in-out;
      left: 0rem;
      font-size: var(--font-size-2);
      padding: 0 8px;
      pointer-events: none;
      position: absolute;
      color: var(--color-grey-9);

      &--error {
        color: var(--color-error);
      }
    }

    height: 48px;
    width: 100%;
    font-size: var(--font-size-3);
    padding: 8px 8px 0 8px;
    appearance: none;
    outline: 0;
    cursor: pointer;
    background: {
      image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjgzIDE2LjQybDkuMTcgOS4xNyA5LjE3LTkuMTcgMi44MyAyLjgzLTEyIDEyLTEyLTEyeiIvPjxwYXRoIGQ9Ik0wLS43NWg0OHY0OGgtNDh6IiBmaWxsPSJub25lIi8+PC9zdmc+');
      position: right 10px center;
      repeat: no-repeat;
      size: 20px auto;
    }
    line-height: 45px;
    text-align: left;

    &[multiple] {
      height: 130px;
      padding: 15px;
      background-image: none;
    }

    &::-ms-expand {
      display: none;
    }
  }
}
</style>
